<div class="block-loading">
  <div class="backdrop-loading--content"></div>
  <img [style]="{ height: '16rem', zIndex: 100000 }" alt="" [src]="srcImgLoading"/>
</div>
